module.exports = __webpack_public_path__ + "NexaBlack.83c7c46eb512f09b6701.otf";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/fonts/NexaBlack.otf
// module id = ../../../../../src/assets/fonts/NexaBlack.otf
// module chunks = 2